import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const Card = ({ imageUrl, title, subtitle, path, customContent, backgroundContent, isTimeline }) => {
  const [textVisible, setTextVisible] = useState(false);
  const cardRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setTextVisible(entry.intersectionRatio === 1);
      },
      { threshold: [1] }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div
      ref={cardRef}
      className="w-full h-[180px] relative overflow-hidden cursor-pointer bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
      onClick={handleClick}
    >
      {customContent ? (
        <div className="h-full flex flex-col">
          <div className="w-full h-full bg-cover bg-center rounded-lg flex items-start justify-center relative pt-4">
            {backgroundContent ? (
              <div className="absolute inset-0">
                {backgroundContent}
              </div>
            ) : (
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${imageUrl || "/fantasy.jpg"})` }}
              />
            )}
            {!isTimeline && <div className="absolute inset-0 bg-beast-brown-900/20" />}
            <div
              className={`relative z-10 text-center text-castle-cream-100 transition-all duration-500 ${
                textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <h1 className="text-xl font-bold bg-opacity-70 bg-beast-brown-900 rounded-sm px-4 py-1">{title}</h1>
              {subtitle && <p className="text-sm font-medium bg-opacity-70 bg-beast-brown-900 rounded-sm m-1 px-4 py-1">{subtitle}</p>}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="w-full h-full bg-cover bg-center rounded-lg flex items-start justify-center pt-4"
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div
            className={`text-center text-castle-cream-100 transition-all duration-500 ${
              textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h1 className="text-xl font-bold bg-opacity-70 bg-beast-brown-900 rounded-sm px-4 py-1">{title}</h1>
            {subtitle && <p className="text-sm font-medium bg-opacity-70 bg-beast-brown-900 rounded-sm m-1 px-4 py-1">{subtitle}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
